<template>
  <div class="d-row" v-if="settingsStore.getServicesLoaded">
    <TileCard id="service-table" class="tile-card" :loaded="settingsStore.getServicesLoaded">
      <template #body>
        <ServiceTable :data="settingsStore.getServices" 
          @teams="showTeams"
          @detail="showServiceDetail">
        </ServiceTable>
        <div class="buttons">
          <button class="accent" @click="() => vfm.open(serviceModalId)">
            <b>+</b>Create service
          </button>
        </div>
      </template>
    </TileCard>
    <TileCard class="d-column tile-card" :loaded="true">
      <template #body>
        <ServiceDetail
          v-if="state.detail"
          :service="state.detail"
          @edit="() => vfm.open(editServiceModalId)"
          @delete="openDeleteServiceModal"
        >
        </ServiceDetail>
        <ServiceTeamsList v-else-if="state.teams" :data="state.teams" @reload="reload" @create-new="onCreateTeamClick">

        </ServiceTeamsList>
      </template>
    </TileCard>
  </div>
  <Loader v-else></Loader>
  <CreateServiceModal
    :modal-id="serviceModalId"
    @close="() => vfm.close(serviceModalId)"
  ></CreateServiceModal>
  <EditServiceModal
    :value="state.detail"
    :modal-id="editServiceModalId"
    @close="() => vfm.close(editServiceModalId)"
    @service="state.detail"
  >
  </EditServiceModal>
  <ConfirmModal
    :modal-id="confirmModalId"
    text="Do you realy want to delete this service?"
    confirm-text="Delete"
    @confirm="confirmDelete"
    @close="vfm.close(confirmModalId)"
  >
  </ConfirmModal>
  <CreateTeamModal :team="state.newTeam" :modal-id="createTeamModalId" @close="closeCreateTeam" @create="onCreateNewTeam">

  </CreateTeamModal>  
</template>

<script setup lang="ts">
import ServiceTable from "@/components/tables/ServiceTable.vue";
import { useVfm } from "vue-final-modal";
import CreateServiceModal from "@/components/modals/CreateServiceModal.vue";
import EditServiceModal from "@/components/modals/EditServiceModal.vue";
import { onMounted, reactive } from "vue";
import { useSettingsStore } from "@/stores/setting";
import ServiceDetail from "@/components/services/ServiceDetail.vue";
import Loader from "@/components/util/Loader.vue";
import ConfirmModal from "@/components/modals/ConfirmModal.vue";
import ServiceTeamsList from "@/components/service_teams/ServiceTeamsList.vue";
import TileCard from "@/components/util/TileCard.vue";
import { useServiceTeamsStore } from "@/stores/serviceTeams";
import CreateTeamModal from "@/components/service_teams/dialogs/CreateTeamModal.vue";
import { ServiceTeamItem } from "@/services/entities/ServiceTeams/ServiceTeamItem";
import { ServiceItem } from "@/services/entities/ServiceItem"

const settingsStore = useSettingsStore();
const serviceModalId = Symbol("serviceModalId");
const editServiceModalId = Symbol("editServiceModalId");
const confirmModalId = Symbol("confirmModalId");
const createTeamModalId = Symbol("createTeamModalId");
const teamsStore = useServiceTeamsStore();
const vfm = useVfm();

const state = reactive({
  detail: null,
  teams: null,
  deleteService: "",
  newTeam: {service: {} as ServiceItem } as  ServiceTeamItem,
});

onMounted(async () => {
  await settingsStore.loadServices();
  await teamsStore.loadServiceTeams();
});

function confirmDelete() {
  vfm.close(confirmModalId);
  deleteService();
}

function openDeleteServiceModal(serviceId: string) {
  state.deleteService = serviceId;
  vfm.open(confirmModalId);
}

async function deleteService() {
  await settingsStore.deleteService(state.deleteService);
  state.detail = null;
  state.newTeam.service.id = -1;
}

function showServiceDetail(serviceId: any) {
  state.teams = null;
  state.newTeam.service.id = serviceId;
  state.detail = settingsStore.getServices.find((a) => a.id == serviceId) as any;
}

function showTeams(serviceId: any) {
  state.detail = null;
  state.newTeam.service.id = serviceId;
  state.teams = teamsStore.getServiceTeams.filter((t) => t.service.id === serviceId) as any;
}

async function reload(serviceId: any) {  
  await teamsStore.loadServiceTeams();
  state.teams = teamsStore.getServiceTeams.filter((t) => t.service.id === serviceId) as any;  
}

async function onCreateNewTeam() {
    vfm.close(createTeamModalId);
    teamsStore.createServiceTeam(state.newTeam);
    reload(state.newTeam.service.id);
}

function closeCreateTeam() {
    vfm.close(createTeamModalId);
}

function onCreateTeamClick() {
    vfm.open(createTeamModalId);
}

</script>

<style scoped lang="scss">
.tile-card {
    overflow: auto;
    height: calc(100vh - 240px);
}
</style>
